import { createProvider } from './providers.js'

import router from 'page'; 


class Router
{
    constructor(base){
        this.base = base;

        if(this.hasBase()){
            this.__set_base(this.base);
        }
    }

    getBase(){
        return this.base;
    }

    hasBase(){
        return !!this.base;
    }

    addRoute(route, ...callbacks){
        router(route, ...callbacks);
    }

    start(options){
        router.start(options);
    }

    __set_base(path){
        router.base(path);
    }

    stop(){
        router.stop();
    }

    historySize(){
        return router.len;
    }

    normalizePath(path){
        if(this.hasBase()){
            return `${this.base}${path}`;
        }else{
            return path;
        }
    }

    show(path){
        router.show(path);
    }

    back(){
        router.back();
    }

    redirect(path){
        router.redirect(path);
    }


    shouldShowBack(){
        // console.log(router.len);
        return !!router.len;
    }
}

const base = "";
const baseDev = "/__artpublic";
export const appRouter = new Router(base);